module.exports = __webpack_public_path__ + "img/logo-black.e50f6308.svg";